import ModalLayout from "../modals/ModalLayout";
import Typography from "../Typography/Typography";
import Button from "../Button/Button";

export default function ConfirmAssetModal({
    assetCount,
    onConfirm,
    onCancel,
    closeModal,
    isSubmitting = false,
}) {
    return (
        <ModalLayout width={500} className="modal-dialog-centered mx-2">
            <div className="card d-flex justify-content-center p-4">
                <ModalLayout.Header>
                    <Typography variant="h4">
                        <div className="w-100 d-flex justify-content-center">
                            Confirm Asset Submission
                        </div>
                    </Typography>
                </ModalLayout.Header>
                <ModalLayout.Body>
                    <div className="text-center py-3">
                        <Typography variant="body1">
                            Are you sure you want to submit <b>{assetCount}</b>{" "}
                            assets to your batch records? This action cannot be
                            undone.
                        </Typography>
                    </div>
                </ModalLayout.Body>
                <ModalLayout.Footer>
                    <div className="d-flex justify-content-end gap-2 w-100 ">
                        <Button
                            variant="secondary"
                            onClick={() => {
                                onCancel?.();
                                closeModal?.();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => {
                                onConfirm?.();
                                closeModal?.();
                            }}
                            disabled={isSubmitting}
                            isLoading={isSubmitting}
                            loadingText="Submitting..."
                        >
                            Confirm
                        </Button>
                    </div>
                </ModalLayout.Footer>
            </div>
        </ModalLayout>
    );
}
